import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { NMAP_CONFIG_API, NMAP_SCAN_API, NMAP_SCANSCHEDULE_API } from "../../vars";
import {getSortAndFilterQueryString} from "../../view/urlService";
import store from "../../app/store";

import { ACTION_SCAN_TYPES_CHANGED, ACTION_SCAN_LIST_CHANGED } from "./VulscanPageReducer";

export function getVulscanConfigs() {
    return securedFetch(NMAP_CONFIG_API)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_SCAN_TYPES_CHANGED)({ scanTypes: data }));
            return data;
        });
}

export async function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return await securedFetch(`${NMAP_SCAN_API}/page?${queryString}`)
    .then(response => response.json())
    .then(data => {
        store.dispatch(createAction(ACTION_SCAN_LIST_CHANGED)({scanList: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}

export function startVulnerabilityScan (typeId, type, command, target) {
    return securedFetch(`${NMAP_SCAN_API}?typeId=${typeId}&type=${type}&command=${command}&target=${target}`, 
                null, 
                'POST')
        .then(response => response.json())     
}

export async function getScanOutputbyId(id) {
   try {
        const response = await securedFetch(`${NMAP_SCAN_API}/${id}`);
        if (response.ok) {
            const jsonResponse = await response.text();
            return jsonResponse;
        }
        return "";
   } catch (error) {
        console.error("Error loading Nmap Scan Output:", error);
        return "";
    }
}


export async function scheduleScan(scanSchedule){
    return securedFetch(`${NMAP_SCANSCHEDULE_API}`, scanSchedule, 'POST' )
    .then(async response =>
        response.json
    )
}

export function updateScheduleActiveFlag(scheduleActiveStatus) {
    const id = scheduleActiveStatus.id;
    const active = scheduleActiveStatus.active;
    return securedFetch(`${NMAP_SCANSCHEDULE_API}/${id}?active=${active}`, null, 'POST')
        .then(response => response.json());
}

export function getScheduledScans(userRole) {
    return securedFetch(`${NMAP_SCANSCHEDULE_API}?userRole=${userRole}`)
        .then(response => response.ok ? response.json() : {});
}


export function deleteScheduleScan(id) {
    return securedFetch(`${NMAP_SCANSCHEDULE_API}/${id}`, null, 'DELETE')
        .then(response => response.json());
}

